module.exports = __webpack_public_path__ + "static/media/partner_pinganyinhang.db90a76e.png";